import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";

export default function ReportModal({ open, onClose, onSelect, loading }) {
  const options = [
    { key: "pdf", label: "Download Corporate PDF" },
    { key: "xlsx", label: "Download Excel Report" },
    { key: "csv", label: "Download CSV" },
    { key: "print", label: "Print Report" },
  ];

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Download Reports</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Select an export format for the dashboard performance report.
        </Typography>
        <List disablePadding>
          {options.map((opt) => (
            <ListItemButton key={opt.key} disabled={loading} onClick={() => onSelect(opt.key)}>
              <ListItemText primary={opt.label} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
